import { Navigate, useLocation } from 'react-router-dom';

interface LegacyRedirectProps {
  /** The old segment(s) under the org, e.g. `accounting/impact`. */
  from: string;
  /** The new segment(s) that replace it, e.g. `impact`. */
  to: string;
}

/**
 * Redirects an old org-scoped URL to its new home, keeping the rest of the
 * address: everything after the old prefix in the pathname, the query string
 * and the hash (`config/legacyRedirects.ts`). The org part of the pathname is
 * carried over from the current location — never rebuilt from an id.
 */
export function LegacyRedirect({ from, to }: LegacyRedirectProps) {
  const { pathname, search, hash } = useLocation();
  const marker = `/${from}`;
  const at = pathname.indexOf(marker);
  const base = at >= 0 ? pathname.slice(0, at) : pathname.replace(/\/$/, '');
  const suffix = at >= 0 ? pathname.slice(at + marker.length) : '';
  return <Navigate to={`${base}/${to}${suffix}${search}${hash}`} replace />;
}
